import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import { TRASH_ICON } from "common/constants"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Trans, useTranslation } from "react-i18next"

export const ModalEliminarContacto = ({
  isOpen = false,
  selectedContacts = [],
  onConfirm,
  onCancel,
}: {
  isOpen: boolean
  selectedContacts?: Array<ContactoReadingDtoProps>
  onConfirm?: () => void
  onCancel?: () => void
}) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-100 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      baseZIndex={20}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Actions'
          className='tw-flex tw-flex-row tw-px-4 tw-pb-1 tw-gap-3'
        >
          <ButtonPrimeReact
            label={`${t("tickets.delete.cancelButton")}`}
            className='tw-w-full tw-h-12 !tw-bg-inherit !tw-text-primary !tw-border-none tw-items-center'
            onClick={onCancel}
          />
          <ButtonPrimeReact
            label={`${t("tickets.delete.confirmButton")}`}
            className='tw-w-full tw-h-12 !tw-bg-danger !tw-border-none tw-text-simple-10 tw-items-center'
            onClick={onConfirm}
          />
        </div>
      }
    >
      <>
        <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center  tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-6'>
          <img
            src={TRASH_ICON}
            alt='Imagen papelera de reciclaje'
          />
        </div>
        <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
          {`${t("contactos.eliminar.modalHeader", {
            count: selectedContacts?.length,
          })}`}
        </div>
        <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-text-center tw-px-4'>
          <p className='tw-mb-6'>
            <Trans
              i18nKey='contactos.eliminar.modalDelete'
              values={{
                count: selectedContacts?.length,
                contactName: selectedContacts[0]?.razonSocial,
              }}
              components={[
                <span
                  className='tw-font-medium tw-contents'
                  key='0'
                />,
              ]}
            />
          </p>
        </div>
      </>
    </PrimeReactModal>
  )
}
